import { EyeOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import { Box, Text } from 'atoms';
import { ACL } from 'components/common';
import { getLocalDate, getLocalTime } from 'utils/helpers';

export function VehicleManagementTableConfig() {
	return [
		{
			title: 'ID',
			dataIndex: 'id',
			key: 'id',
			render: (id) => <Text overFlow="hidden">{id || ''}</Text>,
		},
		{
			title: 'Vehicle Type',
			dataIndex: 'vehicle_type',
			key: 'vehicle_type',
			render: (vehicle_type) => <Text overFlow="hidden">{vehicle_type || ''}</Text>,
		},
		{
			title: 'Maker',
			dataIndex: 'info',
			key: 'info',
			render: (info) => <Text overFlow="hidden">{info?.maker || ''}</Text>,
		},
		{
			title: 'Mode',
			dataIndex: 'info',
			key: 'info',
			render: (info) => <Text overFlow="hidden">{info?.drive_mode || ''}</Text>,
		},
		{
			title: 'Model',
			dataIndex: 'info',
			key: 'info',
			render: (info) => <Text overFlow="hidden">{info?.model || ''}</Text>,
		},
		{
			title: 'Capacity',
			dataIndex: 'info',
			key: 'info',
			render: (info) => <Text overFlow="hidden">{info?.capacity || ''}</Text>,
		},
		{
			title: 'Created At',
			dataIndex: 'created_at',
			key: 'created_at',
			render: (created_at) => (
				<Box>
					<Text overFlow="hidden">{getLocalDate(created_at)}</Text>

					<Text overFlow="hidden" fontStyle="italic">
						{getLocalTime(created_at)}
					</Text>
				</Box>
			),
		},
		{
			title: 'View',
			dataIndex: 'id',
			key: 'id',
			hidden: false,
			render: (id) => (
				<ACL action="update" module="driver">
					<Link to={`/vehicles/${id}?`}>
						<EyeOutlined />
					</Link>
				</ACL>
			),
		},
	];
}
